import '@fontsource-variable/ibm-plex-sans/wght.css'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/500.css'
import './styles/main.css'
import { router } from './router'
import { init_theme } from './lib/theme'
import { install_number_input_wheel_guard } from './lib/number-input-wheel-guard'

install_number_input_wheel_guard()

async function init(): Promise<void> {
  init_theme()

  const root = document.getElementById('app')
  if (!root) throw new Error('Missing #app container')

  router.setup(root)
  await router.navigate(window.location.pathname, false)
}

init().catch((err) => {
  console.error('Init failed:', err)
})
